import {Component, Input, OnInit} from '@angular/core';


@Component({
    selector: 'chart-process-detail',
    imports: [],
    templateUrl: './chart-process-detail.component.html'
})
export class ChartProcessDetailComponent implements OnInit {

  @Input() process: any;
  constructor() {

  }

  ngOnInit() {
  }

}
